import PropTypes from "prop-types";
import SeccionWrapper from "../SeccionWrapper";
import StepPortada from "../../FormularioPropuestaV2/steps/StepPortada";
import SolicitanteActualCard from "../SolicitanteActualCard";

const SeccionPortada = ({ formik, camposIA, desmarcarCampoIA, faltantes }) => (
  <SeccionWrapper
    id="seccion-portada"
    numero={1}
    titulo="Portada"
    faltantes={faltantes}
  >
    <SolicitanteActualCard
      solicitante={formik.values.solicitanteData}
      onSolicitanteActualizado={(actualizado) =>
        formik.setFieldValue("solicitanteData", actualizado)
      }
    />
    <StepPortada
      formik={formik}
      camposIA={camposIA}
      desmarcarCampoIA={desmarcarCampoIA}
    />
  </SeccionWrapper>
);

SeccionPortada.propTypes = {
  formik: PropTypes.object.isRequired,
  camposIA: PropTypes.instanceOf(Set),
  desmarcarCampoIA: PropTypes.func,
  faltantes: PropTypes.arrayOf(PropTypes.string),
};

export default SeccionPortada;
